module.exports = __webpack_public_path__ + "img/download_icon.adbd3e4e.svg";